module.exports = __webpack_public_path__ + "static/img/book18.7dc9d54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book18.jpg
// module id = kcyV
// module chunks = 1